import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CdkDragDrop, CdkDropList, DragDropModule } from '@angular/cdk/drag-drop';
import { TranslateModule } from '@ngx-translate/core';
import { NgForOf } from '@angular/common';
import { MapItem } from '../../../experiment-design.service';

@Component({
    selector: 'jhi-map-section',
    standalone: true,
    imports: [
        DragDropModule,
        TranslateModule,
        NgForOf
    ],
    templateUrl: './map-section.component.html',
    styleUrl: './map-section.component.scss'
})
export class MapSectionComponent {

    @ViewChild('group') internalDropList: CdkDropList<MapItem[]>;

    @Input() groupName: string;
    @Input() mapItems: MapItem[] = [];
    @Input() connectedLists: CdkDropList<MapItem[]>[] = [];
    @Input() drop: (event: CdkDragDrop<MapItem[]>) => void;
    @Output() remapItem = new EventEmitter<MapItem>();

    onRemapItem(item: MapItem) {
        this.remapItem.emit(item);
    }
}
